export default __webpack_public_path__ + "203747ed62e9a9a8580629a23e3c5701.woff2";